/* @flow */
import * as React from 'react';

const ArrowIndigoUp = props => (
  <svg width={12} height={16} viewBox="0 0 12 16" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#283060"
      fillRule="evenodd"
      d="M7,15 L7,2 L11,6 C11.324,6.367 11.641,6.376 12,6 C11.947,6.088 12,5.956 12,6 C12,5.7 11.955,5.576 12,5 L7,0 C6.823,0.117 6.8,0.111 7,0 C6.736,0.069 6.719,0.05 7,0 C6.654,0.025 6.623,0.023 7,0 C6.564,0.013 6.536,0.002 7,0 C6.463,0.002 6.435,0.013 6,0 C6.376,0.024 6.345,0.025 6,0 C6.28,0.05 6.263,0.069 6,0 C6.199,0.111 6.176,0.117 6,0 C6.14,0.154 1,5 1,5 C0.947,5.68 0.956,5.996 1,6 C1.358,6.376 1.675,6.365 2,6 L6,2 L6,15 C6,15.776 6.224,16 6,16 C6.776,16 7,15.776 7,15 Z"
    />
  </svg>
);

export default ArrowIndigoUp;



// WEBPACK FOOTER //
// ./src/assets/images/icons/arrow-indigo-up.js